<template>
	<v-sheet>
		<v-card>
			<v-card-title>编辑价格等级</v-card-title>
			<v-card-text>
				<div class="d-flex flex-row align-center">
					<v-text-field
						label="名称"
						v-model="form.name"
						style="max-width: 20rem"
						:error-messages="errors.name"
					></v-text-field>
					<v-text-field
						label="编码"
						v-model="form.code"
						style="max-width: 20rem"
						:error-messages="errors.code"
					></v-text-field>
				</div>
				<v-textarea
					label="描述"
					v-model="form.description"
					style="max-width: 100rem"
					rows="2"
					:error-messages="errors.description"
				></v-textarea>
				<div class="d-flex flex-row align-center justify-start">
					类型：
					<v-radio-group v-model="form.type" inline style="max-width: 10rem">
						<v-radio
							v-for="item in refs['LevelType']"
							:key="item.value"
							:label="item.title"
							:error-messages="errors.type"
							:value="item.value"
						></v-radio>
					</v-radio-group>
				</div>
				<div class="d-flex flex-row align-center">
					<v-text-field
						label="折扣"
						type="number"
						min="0.01"
						max="1"
						style="max-width: 20rem"
						v-model.number="form.discount"
						:error-messages="errors.discount"
						hint="以零售基础价为基准"
					>
						<template #append></template>
					</v-text-field>
				</div>
				<div class="d-flex flex-row align-center">
					<v-text-field
						label="生效数量下限"
						style="max-width: 20rem"
						v-model="form.lowerbound"
						:error-messages="errors.lowerbound"
					>
						<template #append>克</template>
					</v-text-field>
				</div>
				<div class="d-flex flex-row align-center">
					状态：
					<v-radio-group v-model="form.status" inline dense hide-details="auto">
						<v-radio
							v-for="item in statuses"
							:key="item.value"
							:label="item.text"
							:error-messages="errors.process"
							:value="item.value"
						></v-radio>
					</v-radio-group>
				</div>
			</v-card-text>
			<v-card-actions>
				<slot name="actions" :object="form"></slot>
			</v-card-actions>
		</v-card>
	</v-sheet>
</template>

<script>
import { clone } from 'lodash-es'

export default {
	props: {
		value: Object,
		errors: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			form: {
				name: 'test'
			},
			refs: {},
			types: [
				{ text: '批发', value: 'B' },
				{ text: '零售', value: 'C' }
			],
			statuses: [
				{ text: '有效', value: 'valid' },
				{ text: '无效', value: 'invalid' }
			]
		}
	},
	mounted() {
		this.form = clone(this.value)
		this.$api.common.meta('price', `LevelType`, (r) => {
			this.refs = r
		})
	},
	watch: {
		value: {
			handler(val) {
				if (val) {
					this.form = clone(val)
				}
			},
			immediate: true
		}
	},
	methods: {
		submitForm() {
			this.$emit('submit', this.form)
		}
	}
}
</script>
